import { render, staticRenderFns } from "./ScoresComponent.vue?vue&type=template&id=7763cf8e&"
import script from "./ScoresComponent.vue?vue&type=script&lang=ts&"
export * from "./ScoresComponent.vue?vue&type=script&lang=ts&"
import style0 from "./ScoresComponent.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports